import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { SalesFollowReasonService } from './sales-follow-reason.service'

@Component({
  selector: 'app-sales-follow-reason',
  templateUrl: './sales-follow-reason.component.html',
  styleUrls: ['./sales-follow-reason.component.css']
})
export class SalesFollowReasonComponent implements OnInit {

  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'salesreason', 'reason_code', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  isLoading: Subject<boolean> = new Subject<boolean>();
  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  salesreasonForm: FormGroup;
  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private SalesFollowReasonService: SalesFollowReasonService) {
    this.salesreasonForm = this.fb.group({
      salesReason: ['', Validators.required],
      reason_code: ['', Validators.required],
      status: ['', Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
  }

  get f() { return this.salesreasonForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    this.salesreasonForm.patchValue({
      salesReason: object.reason,
      reason_code: object.reason_code,
      status: object.status ? 1 : 0
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  create() {
    this.submitted = true
    if (this.salesreasonForm.valid) {
      const salesReasonData = this.salesreasonForm.value;
      let obj = {
        "reason": salesReasonData.salesReason,
        "reason_code": salesReasonData.reason_code,
        "status": parseInt(salesReasonData.status),
        "flag": "create"
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.SalesFollowReasonService.salesFollowCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Sales Follow Reason created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.salesreasonForm.valid) {
      const salesReasonData = this.salesreasonForm.value;
      let obj = {
        "reason": salesReasonData.salesReason,
        "reason_code": salesReasonData.reason_code,
        "status": parseInt(salesReasonData.status),
        "flag": "update",
        "id": this.selectedObject.id
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.SalesFollowReasonService.salesFollowCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Sales Follow Reason updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.salesreasonForm.patchValue({
      salesReason: '',
      status: ''
    });
  }

  allowAlphabetsSplcharsOnly(event: any) {
    this.sharedService.allowAlphabetsSplcharsOnly(event);
  }

  getList() {
    let reqObject = {
      flag: 'list'
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.SalesFollowReasonService.salesFollowCrud(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

   public searchInput = new FormControl("");
  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const reason = data.reason.toLowerCase().includes(filter);
      const code = data.reason_code.toLowerCase().includes(filter);
      return reason || code;
    };
      this.dataSource.filter = filterValue;
  }
   clearSearch() {
    this.searchInput.setValue('');
    this.applyFilter();
  }
}
